import React from 'react'
import ReactDOM from 'react-dom'
import { AppForm } from "./AppForm"
import { Intro } from './Intro'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/styles'
import { theme } from './theme/theme'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { Consent } from './Consent'

const rootElement = document.getElementById("root")

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

function App () {
  return (
    <ThemeProvider theme={theme}>
      <Router basename="/">
        <Switch>
          <Route exact path="/">
            <Intro/>
          </Route>
          <Route exact path="/consent">
            <Consent/>
          </Route>
          <Route path="/form">
            <AppForm/>
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  )
}

ReactDOM.render(<React.StrictMode><App/></React.StrictMode>, rootElement)
